import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { WfhRoutingModule } from './wfh-routing.module';
import { WfhComponent } from './wfh.component';
import { WfhDetailsComponent } from './components/wfh-details/wfh-details.component';
import { WfhCreateComponent } from './components/wfh-create/wfh-create.component';


@NgModule({
  declarations: [WfhComponent,WfhDetailsComponent,WfhCreateComponent],
  imports: [
    CommonModule,
    WfhRoutingModule,
    SharedModule,
  ]
})
export class WfhModule { }
